import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';
import { Subscription } from 'rxjs';
import { ToolsControlService } from '../services/tools-control.service';
import { MenuManagementService } from '../menu/services/menu-management.service';
import { TabsService } from '../services/tabsService';

@Component({
  selector: 'app-terrain-watermark',
  templateUrl: './terrain-watermark.component.html',
  styleUrl: './terrain-watermark.component.scss',
  standalone: false
})
export class TerrainWatermarkComponent implements OnInit, OnDestroy {

  terrainName: string = '';
  private terrainsSub: Subscription;

  constructor(
    private configurationController: ConfigurationService,
    public tabsService: TabsService,
    public menuService: MenuManagementService

  ) {}

async ngOnInit() {
  this.terrainsSub = this.configurationController.savedTerrains$.subscribe(terrains => {
    //TODO: Needs to be aligned with the final Copernicus terrain model name 
    this.terrainName = terrains[0]?.name === "Copernicus" ? "Copernicus" : '';
  });
}

  ngOnDestroy() {
    this.terrainsSub.unsubscribe();
  }

}
